;(function () {
	const imageGridSlider = () => {
		const sections = document.querySelectorAll('.as-image-grid-slider');
		if (!sections) return;

		sections.forEach(section => {
            // pc端
			const calcHeight = () => {
				const cards = section.querySelectorAll('.card');
				if (!cards) return;

				cards.forEach((card) => {
                    const cardContentWrapper = card.querySelector('.as-card-content-wrapper');
                    const cardContent = card.querySelector('.as-card-content');
                    const cardTitle = card.querySelector('.as-card-title');
                    if (!cardContentWrapper) return;
                    const cardContentWrapperHeight = cardContentWrapper.offsetHeight;
                    const padding = getElementPadding(cardContentWrapper);
                    if (cardTitle) {
                        let titleTransformHeight = cardContentWrapperHeight - (cardTitle?.offsetTop + cardTitle?.offsetHeight);
                        cardTitle.setAttribute('style', `--transform-height: calc(${titleTransformHeight}px - ${padding.top}px)`);
                    }

                    if (cardContent) {
                        let contentTransformHeight = cardContentWrapperHeight - cardContent?.offsetTop;
                        cardContent.setAttribute('style', `--transform-height: calc(${contentTransformHeight}px - ${padding.top}px)`);
                    }
                });
			};
            function getElementPadding(el) {
                const style = window.getComputedStyle(el);
                return {
                    top: parseFloat(style.paddingTop) || 0,
                    right: parseFloat(style.paddingRight) || 0,
                    bottom: parseFloat(style.paddingBottom) || 0,
                    left: parseFloat(style.paddingLeft) || 0
                };
            }
            calcHeight();
            window.addEventListener('resize', calcHeight);

            // 移动端
            const mobileSwiperEl = section.querySelector('.as-image-grid-mobile-swiper');
            if (mobileSwiperEl) {
                const isAutoplay = mobileSwiperEl.getAttribute('data-autoplay') === 'true';
                const speed = parseFloat(mobileSwiperEl.getAttribute('data-speed')) * 1000; 
                const delay = parseFloat(mobileSwiperEl.getAttribute('data-delay')) * 1000;

                const swiperConfig = {
                    slidesPerView: 1,
                    centeredSlides: true,
                    spaceBetween: 8,
                    loop: false,
                    speed: speed,
                    pagination: {
                        el: mobileSwiperEl.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                    navigation: {
                        nextEl: mobileSwiperEl.querySelector('.mobile-nav-next') || null,
                        prevEl: mobileSwiperEl.querySelector('.mobile-nav-prev') || null
                    }
                };

                if (isAutoplay) {
                    swiperConfig.autoplay = {
                        delay: delay,
                        disableOnInteraction: false,
                        waitForTransition: false
                    };
                }

                new Swiper(mobileSwiperEl, swiperConfig);
            }
		});
	};

	document.addEventListener('DOMContentLoaded', function () {
		imageGridSlider();
		document.addEventListener('shopify:section:load', function () {
			imageGridSlider();
		});
	});
})();